import React from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { IoChatbubble } from "react-icons/io5";

const DeliveryInProgress = ({ orders }) => {
  const ordersOutForDelivery = orders.filter(
    (order) => order.orderStatus === "outForDelivery"
  );

  return (
    <section className="in-progress-container">
      <h2>
        Delivery In Progress <span>{ordersOutForDelivery?.length}</span>
      </h2>

      <div className="in-progress-row-header">
        <h3>Customer</h3>
        <h3>Amount</h3>
        <h3>Order</h3>
        <h3>Status</h3>
        <h3></h3>
        <h3></h3>
      </div>

      <div className="in-progress-customer-details">
        {ordersOutForDelivery.length > 0 ? (
          ordersOutForDelivery.map((order, index) => (
            <React.Fragment key={order.id || index}>
              <div className="customer-info">
                <img
                  src={order.items[0].image || "/avatars/sienna.jpg"}
                  alt={order.customerName || "Customer"}
                />
                <span>{order.customer.name || "Customer Name"}</span>
              </div>

              <span>${order.totalAmount || "0.00"}</span>
              <span>#{order.orderNumber || "00000"}</span>

              <span className="status-badge">
                <span className="dot"></span>
                {order.status || "Delivery in progress"}
              </span>

              {/* <div className="connect-icons">
                <FaPhoneAlt />
                <IoChatbubble />
              </div> */}

              <div className="connect-option">⋮</div>
            </React.Fragment>
          ))
        ) : (
          <p className="no-orders-text">No orders out for delivery.</p>
        )}
      </div>
    </section>
  );
};

export default DeliveryInProgress;
